// Rows use separate flex layouts on native and web. Size columns once from the
// whole table so short labels/numbers leave room for prose and every row aligns.
// This is a bounded text estimate, not a DOM measurement; it also works before
// native layout and does not measure/mount another copy of a streaming table.
export function tableColumnWidths(rows, availableWidth = 0, fontSize = 17) {
  const count = Math.max(1, ...rows.map(row => row.length));
  const glyph = Math.max(6, fontSize * 0.54);
  const measure = value => Math.max(0, ...String(value ?? '').split(/\r?\n/).map(line =>
    Array.from(line).reduce((width, char) => width + (char.codePointAt(0) > 0x2e7f ? 2 : 1), 0))) * glyph + 18;
  const columns = Array.from({ length: count }, (_, index) => {
    const header = measure(rows[0]?.[index]);
    const body = Math.max(0, ...rows.slice(1).map(row => measure(row[index])));
    const min = Math.max(64, Math.min(header, 140), Math.min(body, 200));
    return { min, ideal: Math.max(min, Math.min(header, 240), Math.min(body, 560)) };
  });
  const minimum = columns.reduce((total, col) => total + col.min, 0);
  const ideal = columns.reduce((total, col) => total + col.ideal, 0);
  const width = Math.max(minimum, Number.isFinite(availableWidth) ? availableWidth : 0);
  if (width < ideal) {
    const fraction = (width - minimum) / (ideal - minimum);
    return columns.map(col => col.min + (col.ideal - col.min) * fraction);
  }
  return columns.map(col => col.ideal * width / ideal);
}
